import { Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { InvVoucherHeader } from "../../models/inv-voucher-header.model";

@Component({
  selector: "ngx-inv-voucher-detail-filter",
  templateUrl: "./inv-voucher-detail-filter.component.html",
  styleUrls: ["./inv-voucher-detail-filter.component.scss"],
})
export class InvVoucherDetailFilterComponent extends BaseFormComponent<InvVoucherHeader> {
  filterList: GridFilter[];
  formGroupIsOk: boolean = false;
  StatusKindIds: number[] = [];
  WarehouseIds: number[] = [];
  DetailLedgerIds: number[] = [];
  ReferenceVoucherKindIds: number[] = [];
  VoucherKindIds: number[] = [];
  ngOnDestroy() {
    super.ngOnDestroy();
    this.filterList = undefined;
    this.StatusKindIds = undefined;
    this.WarehouseIds = undefined;
    this.DetailLedgerIds = undefined;
    this.ReferenceVoucherKindIds = undefined;
    this.VoucherKindIds = undefined;
  }
  async ngOnInit() {
    this.label = "فیلتر اقلام";
    super.ngOnInit();
  }
  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "از شماره",
      controlType: FormControlTypes.textbox,
      modelName: "StartVoucherNo",
      disabled: false,
      name: "StartVoucherNo",
      order: 0,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: "تا شماره",
      controlType: FormControlTypes.textbox,
      modelName: "EndVoucherNo",
      disabled: false,
      name: "EndVoucherNo",
      order: 1,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: "از تاریخ",
      controlType: FormControlTypes.datePicker,
      modelName: "StartVoucherDate",
      disabled: false,
      name: "StartVoucherDate",
      order: 2,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: "تا تاریخ",
      controlType: FormControlTypes.datePicker,
      modelName: "EndVoucherDate",
      disabled: false,
      name: "EndVoucherDate",
      order: 3,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
  }
  async save() {
    let entity = this.formGroup.value;
    let filters: GridFilter[] = [];
    Object.keys(this.formGroup.controls).forEach((key) => {
      this.model[key] = this.formGroup.controls[key].value;
      if (this.formGroup.controls[key].value && (!key.includes("Ids") || this.formGroup.controls[key].value.length > 0))
        filters.push({ Filed: key, Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.formGroup.controls[key].value, Logic: "and" });
    });
    this.result = filters;
    this.closeModal();
  }
  addControl(): void {
    this.formGroupIsOk = false;
    this.setValue("StatusKindIds", this.StatusKindIds);
    this.setValue("WarehouseIds", this.WarehouseIds);
    this.setValue("DetailLedgerIds", this.DetailLedgerIds);
    this.setValue("ReferenceVoucherKindIds", this.ReferenceVoucherKindIds);
    this.setValue("VoucherKindIds", this.VoucherKindIds);
    this.formGroupIsOk = true;
    this.cd.markForCheck();
  }
}
